// Importing the XMarkIcon component from Heroicons for the sidebar close button
//import { XMarkIcon } from '@heroicons/react/24/solid';
// Importing the Link component from react-router-dom to enable navigation
import { Link } from 'react-router-dom';
// Importing a custom hook useAuth to get authentication details of the user
import {useAuth} from "../../../hooks/useAuth";
import { Home, BookOpen, MessageCircle, User, Search, PlusCircle, X } from 'lucide-react';

// Defining the props interface for the Sidebar component
interface SidebarProps {
  // Boolean flag indicating whether the sidebar is open
  isSidebarOpen: boolean;
  // Function to set the sidebar open state
  setIsSidebarOpen: (open: boolean) => void;
}
// Sidebar functional component definition
function Sidebar({ isSidebarOpen, setIsSidebarOpen }: SidebarProps) {
  // Using the useAuth hook to get the current authenticated user
  const { user } = useAuth();
  return (
  <aside
    className={`fixed inset-y-0 left-0 w-64 bg-white shadow-2xl transform ${
      isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
    } md:hidden transition-transform duration-300 ease-in-out z-50`}
  >
    <div className="flex flex-col h-full p-6">
      {/* Close button */}
      <button
        className="self-end mb-6 text-gray-600 hover:text-blue-700 p-2 rounded-full transition-colors duration-200"
        onClick={() => setIsSidebarOpen(false)}
        aria-label="Close sidebar"
      >
        <X className="h-6 w-6" />
      </button>

      {/* Navigation links */}
      <ul className="flex-1 space-y-4">
        <li>
          <Link
            to="/"
            className="flex items-center p-3 text-gray-700 hover:bg-blue-50 hover:text-blue-700 rounded-xl transition-colors duration-200"
          >
            <Home className="w-5 h-5 mr-3" /> Home
          </Link>
        </li>
        <li>
          <Link
            to="/courses"
            className="flex items-center p-3 text-gray-700 hover:bg-blue-50 hover:text-blue-700 rounded-xl transition-colors duration-200"
          >
            <BookOpen className="w-5 h-5 mr-3" /> Courses
          </Link>
        </li>
        <li>
          <Link
            to="/chat"
            className="flex items-center p-3 text-gray-700 hover:bg-blue-50 hover:text-blue-700 rounded-xl transition-colors duration-200"
          >
            <MessageCircle className="w-5 h-5 mr-3" /> Chat
          </Link>
        </li>
        <li>
          <Link
            to="/profile"
            className="flex items-center p-3 text-gray-700 hover:bg-blue-50 hover:text-blue-700 rounded-xl transition-colors duration-200"
          >
            <User className="w-5 h-5 mr-3" /> Profile
          </Link>
        </li>

        {user?.role === 'teacher' && (
          <>
            <li>
              <Link
                to="/search-users"
                className="flex items-center p-3 text-gray-700 hover:bg-blue-50 hover:text-blue-700 rounded-xl transition-colors duration-200"
              >
                <Search className="w-5 h-5 mr-3" /> Search Users
              </Link>
            </li>
            <li>
              <Link
                to="/courses/create"
                className="flex items-center p-3 text-gray-700 hover:bg-blue-50 hover:text-blue-700 rounded-xl transition-colors duration-200"
              >
                <PlusCircle className="w-5 h-5 mr-3" /> Create Course
              </Link>
            </li>
          </>
        )}
      </ul>
    </div>
  </aside>
);
}
export default Sidebar;